module.exports = __webpack_public_path__ + "static/machete-season-d5683b426e855a10c2edd18b9cd44798.jpg";